import {getQuanmaiApi,postQuanmaiApi,putUserApi,getUserApi,getShopApi} from './proxy'
export default class {
  //根据用户ID获取用户信息（个人中心）
  GetUserById(data) {
    return getQuanmaiApi('/Users/getUserById', data);
  }
     //退出登录
     lognOut(data) {
      return getUserApi('/api/logout',{});
    }
    
  //获取其他用户的个人信息
  getOtherUserInfo(data) {
    return getQuanmaiApi('/Users/getOtherUserInfo', data);
  }
  //修改个人信息（个人中心）
  EditUser(data) {
    return putUserApi('/api/userinfo',data)
   }
   //获取版本信息
   Getversion() {
    return getQuanmaiApi("/Index/getConf", {})
  }
  //获取未读提醒列表接口
getUnReadTip(data){
  return getQuanmaiApi('/Messages/getUnReadTip', data);
}
//点击查看提醒
// c2c代表C2C规则引导,
// c2c_recomment_guide代表粉丝推荐二维码（引导提示）,
// zixun代表健康咨询引导,
// new_card代表新人卡评估引导,
// user_card代表个人中心卡包引导,
// agency_team_rule代表我的代理团队（规则引导）,
// agency_team_develop代表代理商发展下线引导
getTipById(data){
  return getQuanmaiApi('/Messages/getTipById', data);
}
//根据多个用户Id获取用户基本信息
GetUserByIds(data) {
  return getQuanmaiApi('/Users/getUserByIds', data);
}

//更新/添加咨询费用
EditPrice(data) {
  return postQuanmaiApi('/Users/editPrice', data);
}
//  获取用户已授权的医生列表
GetAuthLst(data) {
  return getQuanmaiApi("/Users/getAuthLst", data)
}
//用户开启/关闭授权
SetAuth(data) {
  return postQuanmaiApi("/Checks/setAuth", data)
}
//获取我的次数卡列表接口
GetMyCard(data) {
  return getQuanmaiApi("/Users/getMyCard", data)
}
// 获取次数卡使用记录列表接口
GetCardUserLst(data) {
  return getQuanmaiApi("/Users/getCardUserLst", data)
}
//用户绑定公司接口
BindCompany(data) {
  return postQuanmaiApi("/Users/bindCompany", data)
}
//用户充值记录
GgetCharge() {
  return getQuanmaiApi("/Users/getCharge", data)
}
//前端获取微信分享的js参数接口
GetWxSign(data) {
  return getQuanmaiApi("/Index/getWxSign",data)
}
//根据文章ID获取详情
getArticleById(data) {
  return getQuanmaiApi("/Articles/getArticleById", data)
}
//周报接口
getweekreport(data) {
  return getQuanmaiApi("/Checks/weekReport", data)
}
//绑定新人卡接口
bindNewCard(data){
return postQuanmaiApi("/Users/bindNewCard", data)
}
//获取用户的评估统计数据
getUserReport(data){
return getQuanmaiApi("/Checks/getUserReport", data)
}
//修改用户接口
CheckseditUser(data){
return postQuanmaiApi('/Checks/editUser', data);
}
//获取公司列表接口
getUserCompany(data){
return getQuanmaiApi('/Users/getUserCompany', data);
}
//健康排名列表接口
scoreList(data){
return getQuanmaiApi('/Checks/scoreList', data);
}

//文章评论/评论回复接口
Addcomment(data){
return postQuanmaiApi('/Articles/comment', data);
}
//评论/回复点赞接口
commentLike(data){
return postQuanmaiApi('/Articles/commentLike', data);
}
//获取文章评论/评论回复列表
GetcommentLst(data){
return getQuanmaiApi('/Articles/commentLst', data);
}
//ocr读取身份证照片接口
ocrReadFile(data){
return postQuanmaiApi('/Index/orcReadFile', data);
}
//获取当前团购的客户列表
getMyTeamCustomer(data){
return getQuanmaiApi('/Teams/getMyTeamCustomer', data);
}
//用户绑定职场
BindCompany(data){
  return postQuanmaiApi('/Users/bindCompany', data);
}
//获取购物车以及订单各状态数量
orderCount(data){
  return getShopApi('/order/order_status_count', data);
}
initUserCount(data){
  return getQuanmaiApi('/Counts/initUserCount',data)
}
initUserSaomaCount(data){
  return getQuanmaiApi('/Counts/initUserSaomaCount',data)
}
   //微信分享
   jsconfig(data){
    return getUserApi('/api/wxai/jsconfig',data);
}
}




// WEBPACK FOOTER //
// ./src/service/userService.js